module.exports = __webpack_public_path__ + "static/img/smartProduct21.b8b44b5e.png";